<template>
  <template v-if="isOpen">
    <button
      class="mt-6 flex items-center space-x-2 font-semibold text-burnt-sienna"
      @click="$emit('closeSubmenu')"
    >
      <ChevronLeftIcon class="size-5" />
      Back
    </button>
    <hr class="my-4 w-full border-burnt-sienna" />
    <div class="mb-4 text-terracota-dark">
      <a v-if="'path' in title" :href="title.path">
        {{ title.label }}
      </a>
      <router-link v-else :to="{ name: title.name }">
        {{ title.label }}
      </router-link>
    </div>
    <div class="flex flex-col space-y-4">
      <template v-for="link in links" :key="link.label">
        <NavBarMobileMenuItem
          :link="link"
          :is-logged-in="isLoggedIn"
          small-text
          @close="$emit('closeWholeMenu')"
        />
      </template>
    </div>
  </template>
</template>

<script lang="ts" setup>
  import { ChildLink, SubmenuGroupTitle } from '@/types/navigation';
  import { ChevronLeftIcon } from '@heroicons/vue/solid';

  interface Props {
    isOpen: boolean;
    title: SubmenuGroupTitle;
    links: ChildLink[];
    isLoggedIn: boolean;
  }

  interface Emits {
    (e: 'closeSubmenu'): void;
    (e: 'closeWholeMenu'): void;
  }

  defineProps<Props>();
  defineEmits<Emits>();
</script>
